import * as React from "react";

import { Confirm, Status } from "./Chapters";

export default ({ key, method }) => {
  switch (key) {
    case "TAG":
      return <Status {...{ method }} />;
    default:
      return <Confirm {...{ method }} />;
  }
};
